module.exports = __webpack_public_path__ + "img/ico_badge_task02.46855d8d.svg";